export default function getPageTitle(pageTitle) {

  if (pageTitle) {
    return `${pageTitle}`
  }

}